import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/hooks/useAuth";

interface ReviewRow {
  booking_id: number | null;
}

export function useReviewedBookings() {
  const { user } = useAuth();
  const [reviewedIds, setReviewedIds] = useState<Set<number>>(new Set());
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) {
      setReviewedIds(new Set());
      setLoading(false);
      return;
    }
    try {
      const { data, error } = await supabase.from("reviews").select("booking_id").eq("reviewer_id", user.id);
      if (error) throw error;
      const rows = (data as ReviewRow[]) ?? [];
      setReviewedIds(
        new Set(rows.map((row) => row.booking_id).filter((id): id is number => typeof id === "number"))
      );
    } catch {
      setReviewedIds(new Set());
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  const markReviewed = useCallback((bookingId: number) => {
    setReviewedIds((prev) => new Set(prev).add(bookingId));
  }, []);

  return { reviewedIds, loading, reload: load, markReviewed };
}